import { Instagram, Mail, Phone, ArrowUpRight } from "lucide-react";
import {
  CONTACT_EMAIL,
  INSTAGRAM_URL,
} from "@/components/landing/content";

const LINKS = [
  {
    label: "DM us on Instagram",
    sub: "@jtbrandscalesky",
    href: INSTAGRAM_URL,
    Icon: Instagram,
    testid: "ql-instagram",
    external: true,
  },
  {
    label: "Email us",
    sub: CONTACT_EMAIL,
    href: `mailto:${CONTACT_EMAIL}`,
    Icon: Mail,
    testid: "ql-email",
  },
  {
    label: "Call the studio",
    sub: "Mon – Sat · 10a – 7p",
    href: "#contact",
    Icon: Phone,
    testid: "ql-call",
  },
];

export default function QuickLinks() {
  return (
    <section
      data-testid="quicklinks-section"
      className="relative -mt-2 mb-2"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid sm:grid-cols-3 gap-3 md:gap-4">
          {LINKS.map(({ label, sub, href, Icon, testid, external }) => (
            <a
              key={testid}
              href={href}
              data-testid={testid}
              target={external ? "_blank" : undefined}
              rel={external ? "noopener noreferrer" : undefined}
              className="group lift flex items-center gap-4 rounded-2xl border border-slate-200 bg-white px-4 py-4 md:px-5 md:py-5"
            >
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-blue-700 text-white">
                <Icon size={18} />
              </span>
              <span className="flex-1 leading-tight">
                <span className="block font-display font-extrabold text-slate-900">
                  {label}
                </span>
                <span className="block text-sm text-slate-500">{sub}</span>
              </span>
              <ArrowUpRight
                size={18}
                className="text-slate-400 group-hover:text-orange-600 transition-colors"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
